

  
const content = `# SecureFile Installation and Configuration
  
OnData SecureFile protects the unstructured data in all types of files and documents at all times. There is no limitation regarding the types of 
files. It can be Office documents, PDF, text files, video/audio files, industrial design files, or any types of files. Such files are strongly
encrypted at all times and dynamically made usable for authorized users only. The purpose of this guide is to detail the procedure to install and 
configure the OnData SecureFile product.
  
OnData SecureFile currently supports the Microsoft Windows operating system and the Apple Mac operating system (MacOS) only, with other operating systems 
such as Linux, iOS and Android, on the product roadmap. Support for those operation systems will be announced as it is made available.  
  
Please refer to sections below on how to install and configure the OnData SecureFile product on Windows and MacOS.
* [Install SecureFile on Windows](reference_doc#securefile/installation_and_configuration/install_securefile_on_windows)
* [Register SecureFile](reference_doc#securefile/installation_and_configuration/register_securefile)
* [Silent Installation on Windows](reference_doc#securefile/installation_and_configuration/silent_installation_on_windows)
* [Install SecureFile on MacOS](reference_doc#securefile/installation_and_configuration/install_securefile_on_macos)
* [SecureFile Settings on MacOS](reference_doc#securefile/installation_and_configuration/securefile_settings_on_macos)
* [Silent Installation on MacOS](reference_doc#securefile/installation_and_configuration/silent_installation_on_macos)
* [Uninstall SecureFile](reference_doc#securefile/installation_and_configuration/uninstall_securefile)

`
  
export default content;
